import React from 'react';

import { FavoriteButton } from '../../components';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

/**
 * The listing gallery, with an optional favorite heart overlaid on the image.
 *
 * @param {Object} props
 * @param {propTypes.listing} props.listing - The listing
 * @param {string} props.variantPrefix - The image variant prefix
 * @param {propTypes.currentUser?} props.currentUser - The current user, if any
 * @param {Function} props.onToggleFavorite - (listingId) => Promise
 * @param {boolean} props.showFavoriteButton - Whether to render the heart (hidden on own listings)
 * @returns {JSX.Element}
 */
const SectionGallery = props => {
  const { listing, variantPrefix, currentUser, onToggleFavorite, showFavoriteButton } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  const favoriteButton = showFavoriteButton ? (
    <FavoriteButton
      listingId={listing.id}
      currentUser={currentUser}
      onToggleFavorite={onToggleFavorite}
    />
  ) : null;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        favoriteButton={favoriteButton}
      />
    </section>
  );
};

export default SectionGallery;
